.ssoButton {
  // Reset
  background: none;
  margin: 0;
  cursor: pointer;

  // Layout
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;

  // Sizing - 51px height per Figma (16px padding + 18px content + 16px padding + 1px border)
  height: 51px;
  padding: 0 map.get($spacing-scale, 'md');

  // Typography
  font-family: $font-family-base;
  @include body-medium;
  line-height: 1; // Override to match Figma's 100% line-height
  text-align: center;
  white-space: nowrap;

  // Visual
  background-color: transparent;
  color: var(--color-text-primary);
  border: 1px solid var(--color-grey-neutral);
  border-radius: map.get($radius, 'md');

  // Transitions
  @include transition(background-color, transform, box-shadow);

  &:hover:not(.disabled) {
    background-color: var(--color-surface-alt);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:active:not(.disabled) {
    background-color: var(--color-surface-alt);
    transform: translateY(0);
  }

  &:focus-visible {
    @include focus-ring;
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.text {
  flex: 1;
  text-align: center;
}

.spacer {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}
